import React from 'react';
import { motion } from 'framer-motion';

const triggerMethods = [
  {
    icon: '📱',
    title: "Application Mobile",
    description: "Un bouton d'alarme central accessible instantanément en ouvrant l'application."
  },
  {
    icon: '🔘',
    title: "Widgets Écran d'accueil",
    description: "Suivez en un coup d'œil votre statut de session et celui de vos proches directement depuis l'écran d'accueil, entièrement personnalisables (voir plus bas)."
  },
  {
    icon: '🤫',
    title: "Raccourcis Physiques",
    description: "Envoi d'alerte avec la touche alimentation (5 appuis rapides consécutifs, activée par défaut) ou, si besoin, avec les touches de volume de votre téléphone — discrètement, à l'insu de l'agresseur."
  },
  {
    icon: '⌚',
    title: "Montres Connectées",
    description: "Support de toutes les grandes marques (Apple Watch, Garmin, FitBit, Xiaomi, HyperOS) pour déclencher l'alerte depuis votre poignet."
  },
  {
    icon: '🚗',
    title: "Détection de Chocs",
    description: "Détection automatique des chocs violents et des accidents de la route en local, déclenchant l'alerte même si vous êtes inconscient."
  }
];

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } }
};

const SecurityConcept = () => {
  return (
    <section 
      id="security-concept" 
      className="section-padding" 
      style={{
        background: 'linear-gradient(180deg, #081222 0%, #060d1a 100%)',
        position: 'relative'
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        
        {/* Header */}
        <div className="text-center" style={{ marginBottom: '60px' }}>
          <span className="badge-gold">⚡ Réactivité Maximale</span>
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 2.8rem)',
            color: 'var(--mga-white)',
            marginTop: '10px',
            marginBottom: '15px'
          }}>
            Un danger ne prévient pas. <span style={{ color: 'var(--mga-gold)' }}>Soyez prêt.</span>
          </h2>
          <p style={{
            maxWidth: '650px',
            margin: '0 auto',
            color: 'var(--mga-slate-300)',
            fontSize: '1.05rem'
          }}>
            Dans une situation d'urgence, chaque seconde compte. C'est pourquoi nous avons développé des méthodes de déclenchement ultra-rapides et discrètes adaptées à chaque contexte.
          </p>
        </div>

        {/* Grid of methods */}
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-100px' }}
          className="features-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '24px',
            marginTop: '40px'
          }}
        >
          {triggerMethods.map((method, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              className="glass-card"
              style={{
                padding: '30px 25px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                border: '1px solid rgba(255, 255, 255, 0.04)',
                background: 'rgba(11, 31, 58, 0.2)'
              }}
            >
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '16px',
                backgroundColor: 'rgba(242, 184, 7, 0.1)',
                border: '1px solid rgba(242, 184, 7, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2rem',
                marginBottom: '20px'
              }}>
                {method.icon}
              </div>
              <h3 style={{
                color: 'var(--mga-white)',
                fontSize: '1.25rem',
                marginBottom: '10px',
                fontFamily: 'var(--font-display)'
              }}>
                {method.title}
              </h3>
              <p style={{
                color: 'var(--mga-slate-300)',
                fontSize: '0.95rem',
                lineHeight: '1.6',
                margin: 0
              }}>
                {method.description}
              </p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default SecurityConcept;
